import React from "react"

import {
  Wrapper,
  InnerWrapper,
  Quote,
  Text,
  Attribution,
  Decoration,
  DecorationCircle,
} from "./styles"

const Pullquote = ({ element, isPremium }) => (
  <Wrapper priority={element.priority} isPremium={isPremium}>
    <InnerWrapper priority={element.priority}>
      <Quote>
        <Text
          priority={element.priority}
          isPremium={isPremium}
          dangerouslySetInnerHTML={{ __html: element.text }}
        />
        {element.attribution && (
          <footer>
            <Attribution priority={element.priority}>{element.attribution}</Attribution>
          </footer>
        )}
      </Quote>
    </InnerWrapper>
    {element.priority === 2 && (
      <Decoration priority={element.priority}>
        <DecorationCircle />
      </Decoration>
    )}
  </Wrapper>
)

export default Pullquote
